import { loadCSS } from '../utils';
let view = null;

export default {
	namespace: 'template-soundtrack',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPURLS.themeUrl + '/dist/css/_soundtrack-page.css');

		const { default: Soundtrack } = await import(/* webpackChunkName: "soundtrack" */ '../vol3/Soundtrack');
		view = new Soundtrack(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
